import { red } from "@mui/material/colors";
import { components } from "./components";
import { typography } from "app/utils/constant";

const themeOptions = {
  // typography: {
  //     fontSize: 14,
  //     body1: { fontSize: '14px' }
  // },
  typography: {
    ...typography,
  },

  status: { danger: red[500] },
  components: { ...components },
};

export default themeOptions;

// import { red } from "@mui/material/colors";
// import { components } from "./components";

// const themeOptions = {
//     typography: {
//         fontSize: 14,
//         body1: { fontSize: '14px' }
//     },

//     status: { danger: red[500] },
//     components: {...components}
// }

// export default themeOptions;
